import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "m-font-size" }, "Вы уверены?", -1)
const _hoisted_2 = { class: "items-in-line" }

import { deleteCategoryValueApi } from '@/api/developer';
import { ref } from 'vue';
import { DeleteCategoryModalType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteDeveloperModal',
  props: {
    deleteCategoryModalData: {}
  },
  emits: ['deleteCategory', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const idDeleteBtnLoading = ref(false);

const closeDeleteCategoryModal = () => {
  emit('close');
};
const deleteCategory = async () => {
  if (props.deleteCategoryModalData.id) {
    idDeleteBtnLoading.value = true;
    try {
      const res = await deleteCategoryValueApi(props.deleteCategoryModalData.id);

      if (res) {
        emit('deleteCategory', props.deleteCategoryModalData.id);
      }
    } finally {
      idDeleteBtnLoading.value = false;
      emit('close', props.deleteCategoryModalData.id);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _ctx.deleteCategoryModalData.show,
    "hide-title": "",
    onClose: closeDeleteCategoryModal
  }, {
    content: _withCtx(() => [
      _hoisted_1
    ]),
    btn: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_button, {
          height: "40",
          "style-type": "coloredBorder",
          text: "Отмена",
          width: "80",
          onClick: closeDeleteCategoryModal
        }),
        _createVNode(_component_base_button, {
          loading: idDeleteBtnLoading.value,
          height: "40",
          text: "Да",
          width: "80",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteCategory()))
        }, null, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["show-modal"]))
}
}

})